import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import React, { useEffect, useState } from "react";
import GenericTable from "@frameworks/web/components/generic/GenericTable";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { NonStreamReportValue } from "@frameworks/web/components/features/Markets/Equity/commonTablemethods";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import ReportValue from "@frameworks/web/components/generic/commonTableVal";
import { THApproximateTrans, THApproximateTransEditsDone, THVIEWS, } from "./Constant";
import { useSelector } from "react-redux";
import moment from "moment";
import di from "./di/servicelocator";
import PNLDI from "@frameworks/web/components/Reports/PNLReports/di/servicelocator";
import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
import EdelSidebarDrawer from "@frameworks/web/components/generic/Sidebar/EdelSidebarDrawer";
import { previousDay } from "@domains/utils/reportDates";
import GenericPopup from "@frameworks/web/components/generic/GenericPopup";
const ApproximateTransaction = (props) => {
    var _a, _b;
    const device = DeviceContext();
    const AccountDetails = useSelector((state) => state.accountDetailsReducer);
    const [openApproxTxnDrawer, setOpenApproxTxnDrawer] = useState(device === null || device === void 0 ? void 0 : device.isMobile);
    const [approximatedEstimates, setApproximatedEstimates] = React.useState({
        editSplitOriginalTransaction: [],
    });
    const [appromiateEstimatesLoader, setAppromiateEstimatesLoader] = React.useState(false);
    const [approximatedEstimsatesError, setApproximatedEstimsatesError] = React.useState(null);
    const [listOfCheckedItems, setListOfCheckedItems] = React.useState([]);
    const [termsAndConditions, setTermsAndConditions] = React.useState(false);
    const [allSelected, setAllSelected] = React.useState(false);
    const THTableColumn = [
        {
            columnName: (React.createElement("input", { type: "checkbox", disabled: (approximatedEstimates === null || approximatedEstimates === void 0 ? void 0 : approximatedEstimates.editSplitOriginalTransaction.filter((x) => x.editable && !x.edited).map((y) => y.tranId).length) === 0, onChange: (event) => {
                    setListOfCheckedItems(() => {
                        if (event.target.checked)
                            return approximatedEstimates === null || approximatedEstimates === void 0 ? void 0 : approximatedEstimates.editSplitOriginalTransaction.filter((x) => !x.edited && x.editable).map((y) => y.tranId);
                        else
                            return [];
                    });
                    if (event.target.checked)
                        setAllSelected(true);
                    else
                        setAllSelected(false);
                }, className: !allSelected && "checked-tickbox" })),
            key: "tranId",
            key2: "edited",
            columnClassName: "common-checkbox-custom",
            tdCustomFunction: (key, key2) => {
                let checked = listOfCheckedItems.findIndex((x) => x === key) > -1;
                return (React.createElement("input", { type: "checkbox", checked: checked, disabled: key2, onChange: (event) => {
                        setListOfCheckedItems((prevState) => {
                            let newList = [...prevState];
                            if (event.target.checked && !newList.includes(key))
                                newList.push(Number(key));
                            else {
                                let idx = listOfCheckedItems.indexOf(key);
                                if (key > -1)
                                    newList.splice(idx, 1);
                            }
                            return newList;
                        });
                    }, className: `${!checked && "checked-tickbox"} ${key2 && "opacity-25"}` }));
            },
        },
        {
            columnName: "Date",
            arrows: true,
            key: "transactionDate",
            key2: "edited",
            applySorting: true,
            type: "Date",
            onlyOneArrowAtaTime: true,
            columnClassName: "text-nowrap",
            tdCustomFunction: (key, key2) => {
                return React.createElement("span", { className: `${key2 && "opacity-25"}` }, key);
            },
        },
        {
            columnName: "Scrip Name",
            arrows: true,
            key: "security",
            key2: "edited",
            applySorting: true,
            type: "string",
            onlyOneArrowAtaTime: true,
            tdCustomFunction: (key, key2) => {
                return React.createElement("span", { className: `${key2 && "opacity-25"}` }, key);
            },
        },
        {
            columnName: "Action",
            arrows: true,
            key: "action",
            key2: "edited",
            applySorting: true,
            type: "string",
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
            tdCustomFunction: (action, edited) => {
                return (React.createElement("span", { className: `${action.toUpperCase() === "BUY" ? "txt_green" : "txt_bloodRed"}
            ${edited && "opacity-25"}` }, action.toUpperCase()));
            },
        },
        {
            columnName: "Quantity",
            arrows: true,
            key: "quantity",
            key2: "edited",
            applySorting: true,
            type: "number",
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
            tdCustomFunction: (val1, edited) => {
                return (React.createElement("span", { className: edited && "opacity-25" }, NonStreamReportValue(String(val1))));
            },
        },
        {
            columnName: "Price",
            arrows: true,
            key: "transactionPrice",
            key2: "edited",
            applySorting: true,
            type: "number",
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
            tdCustomFunction: (val1, edited) => {
                return (React.createElement("span", { className: edited && "opacity-25" }, NonStreamReportValue(String(val1))));
            },
        },
        {
            columnName: "Net Value",
            arrows: true,
            key: "netValue",
            key2: "edited",
            applySorting: true,
            type: "number",
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
            tdCustomFunction: (val1, edited) => {
                return (React.createElement("span", { className: edited && "opacity-25" }, NonStreamReportValue(String(val1))));
            },
        },
        {
            columnName: "Action",
            keysForCustomFunction: ["editable", "tranId", "edited"],
            columnClassName: "common-numeric-arrows numeric-value taRight",
            tdCustomFunction: (values) => {
                let [editable, tranId, edited] = values;
                let payload = {
                    pnLEditSplitRequests: [{ transactionId: Number(tranId) }],
                };
                if (editable) {
                    if (!edited)
                        return (React.createElement("div", { className: "hand_cursor", onClick: () => {
                                if (editable) {
                                    PNLDI.pnlTransactionReport.getOriginalTxns(payload);
                                    props.seteditTransaction(true);
                                }
                            } },
                            React.createElement("i", { className: "edel-icon-edit-icon-large txt-midnight-blue" })));
                    return (React.createElement("div", { className: "d-flex justify-content-end " },
                        React.createElement("div", { className: "w-auto posrel", id: tranId + "tag" },
                            React.createElement(GenericPopup, { containerDom: document.getElementById(tranId + "tag"), placement: "top", triggerType: "hover", button: React.createElement("i", { className: "edel-icon-Timer-refresh" }), children: React.createElement(React.Fragment, null, " Transaction currently processing"), isHeadline: true, parentClass: "rebrandreports-tooltip-hover" }))));
                }
                return null;
            },
        },
    ];
    const approximateTableErrorHandling = () => {
        if ((approximatedEstimates === null || approximatedEstimates === void 0 ? void 0 : approximatedEstimates.editSplitOriginalTransaction.length) < 1) {
            const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.TXN];
            return {
                msg: emptyValidation.message,
                show: true,
                icon: emptyValidation.icon,
            };
        }
        else if (!!approximatedEstimsatesError) {
            const emptyValidation = EmptyValidation[EmptyIcon.ERROR];
            return {
                msg: emptyValidation.message,
                show: !!approximatedEstimsatesError,
                icon: emptyValidation.icon,
            };
        }
    };
    const saveApproximations = () => {
        let editableTransaction = approximatedEstimates === null || approximatedEstimates === void 0 ? void 0 : approximatedEstimates.editSplitOriginalTransaction.filter((m) => m.editable && !m.edited).filter((n) => listOfCheckedItems.includes(n.tranId)).map((x) => {
            return {
                transactionId: x.tranId,
                editFlag: x.editFlag,
                newDate: moment(x.transactionDate).format("yyyy-MM-DD"),
                newQuantity: x.quantity,
                newPrice: x.transactionPrice,
            };
        });
        const payload = {
            accountId: AccountDetails.accountCode,
            fromDate: moment(props.startDate).format("yyyy-MM-DD"),
            toDate: moment(props.endDate).format("yyyy-MM-DD"),
            pnLEditSplitRequests: editableTransaction,
            approximated: true,
        };
        PNLDI.pnlTransactionReport.sendEditSplitPNLTransactionData(payload);
    };
    useEffect(() => {
        var _a, _b;
        if (((_a = props.editableTxns) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let payload = {
                transactionIds: (_b = props === null || props === void 0 ? void 0 : props.editableTxns) === null || _b === void 0 ? void 0 : _b.map((x) => x.tranId),
            };
            setAppromiateEstimatesLoader(true);
            setListOfCheckedItems([]);
            di.transactionHistory
                .getApproximateTransactions(payload)
                .then((x) => {
                setApproximatedEstimates(x);
            })
                .catch((error) => {
                setApproximatedEstimsatesError(error);
            })
                .finally(() => {
                setAppromiateEstimatesLoader(false);
                setTermsAndConditions(false);
            });
        }
    }, [(_a = props === null || props === void 0 ? void 0 : props.editableTxns) === null || _a === void 0 ? void 0 : _a.length]);
    if (device === null || device === void 0 ? void 0 : device.isMobile)
        return (React.createElement(EdelSidebarDrawer, { openKey: openApproxTxnDrawer, setOpenKey: (openKey) => {
                setOpenApproxTxnDrawer(openKey);
            }, standalonePage: device === null || device === void 0 ? void 0 : device.isMobile, hideDrawerHandle: true, backgroundTheme: "bg_white", placement: "bottom", drawerHeightClass: "height-100", header: React.createElement("div", { className: "d-flex align-items-center " },
                React.createElement("i", { className: "edel-icon-arrow-left hand_cursor", onClick: () => props.setTHViews(THVIEWS.MAIN_LANDING) }),
                React.createElement("span", { className: "DMSansMedium_20_500" }, "Approximated Transactions")), body: React.createElement("div", { className: "" },
                React.createElement(ErrorExclamation, { avoidExclamation: true, parentClass: "error-authorize-approximate  mb-20", errorMessage: THApproximateTrans }),
                React.createElement("div", { className: "seperator-border-top" }),
                appromiateEstimatesLoader ? (React.createElement(Common_Shimmer, null)) : approximatedEstimsatesError ? (React.createElement(ErrorNotification, { error: approximatedEstimsatesError, displayType: ErrorDisplayType.INSECTION, isOpen: !!approximatedEstimsatesError })) : (React.createElement("div", null, (_b = approximatedEstimates === null || approximatedEstimates === void 0 ? void 0 : approximatedEstimates.editSplitOriginalTransaction) === null || _b === void 0 ? void 0 :
                    _b.map((data, idx) => (React.createElement("div", { className: "details-row-history approx-details-row-history", key: idx },
                        React.createElement("div", { className: "d-flex align-items-baseline justify-content-between" },
                            React.createElement("div", { className: `displayFlex gap-10 ${data.edited ? "opacity-50" : ""}` },
                                React.createElement("input", { disabled: data.edited, type: "checkbox", checked: listOfCheckedItems.findIndex((x) => x === data.tranId) > -1, className: "common-checkbox-custom", onChange: (event) => {
                                        setListOfCheckedItems((prevState) => {
                                            let newList = [...prevState];
                                            if (event.target.checked &&
                                                !newList.includes(data.tranId))
                                                newList.push(Number(data.tranId));
                                            else {
                                                let idx = listOfCheckedItems.indexOf(data.tranId);
                                                if (data.tranId > -1)
                                                    newList.splice(idx, 1);
                                            }
                                            return newList;
                                        });
                                    } }),
                                React.createElement("span", { className: "DMSan_14_700 security", onClick: () => {
                                        props === null || props === void 0 ? void 0 : props.handleRowClick(data);
                                    } }, data === null || data === void 0 ? void 0 : data.security)),
                            React.createElement("div", { className: `d-flex align-items-center justify-content-end gap-1` }, data.editable ? (React.createElement("div", { onClick: () => props.handleRowClick(data), className: "justify-self-end" }, data.edited ? (React.createElement("div", { className: "d-flex justify-content-end " },
                                React.createElement("div", { className: "w-auto posrel", id: (data === null || data === void 0 ? void 0 : data.tranId) + "tag" },
                                    React.createElement(GenericPopup, { containerDom: document.getElementById((data === null || data === void 0 ? void 0 : data.tranId) + "tag"), placement: "top", triggerType: "hover", button: React.createElement("i", { className: "edel-icon-Timer-refresh" }), children: React.createElement(React.Fragment, null, " Transaction currently processing"), isHeadline: true, parentClass: "rebrandreports-tooltip-hover" })))) : (React.createElement("div", { onClick: () => {
                                    if (data.editable) {
                                        let payload = {
                                            pnLEditSplitRequests: [
                                                {
                                                    transactionId: Number(data.tranId),
                                                },
                                            ],
                                        };
                                        PNLDI.pnlTransactionReport.getOriginalTxns(payload);
                                        props.seteditTransaction(true);
                                        props.handleRowClick(data);
                                    }
                                } },
                                React.createElement("i", { className: "edel-icon-edit-icon-large txt-midnight-blue" }))))) : null)),
                        React.createElement("div", { className: `mt-3 ${data.edited ? "opacity-50" : ""}` },
                            React.createElement("div", { className: "mobile-summ-row" },
                                React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                    React.createElement("span", { className: "txt_secondary-gray DMSansNormal_12_400" }, "Date"),
                                    React.createElement("span", { className: "RobotoM_14_500 text-nowrap" }, data === null || data === void 0 ? void 0 : data.transactionDate)),
                                React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                    React.createElement("span", { className: "txt_secondary-gray DMSansNormal_12_400" }, "Action"),
                                    React.createElement("span", { className: `DMSanM_10_500 text-uppercase
                                                ${data.action.toUpperCase() ===
                                            "BUY"
                                            ? "txt_green"
                                            : "txt_bloodRed"}` }, data.action))),
                            React.createElement("div", { className: "mobile-summ-row" },
                                React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                    React.createElement("span", { className: "txt_secondary-gray DMSansNormal_12_400" }, "Price"),
                                    React.createElement("span", { className: "RobotoM_14_500" },
                                        React.createElement(ReportValue, { val: data.transactionPrice, stream: false, onlyval: false }))),
                                React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                    React.createElement("span", { className: "txt_secondary-gray DMSansNormal_12_400" }, "Qty"),
                                    React.createElement("span", { className: "RobotoM_14_500 num" },
                                        React.createElement(ReportValue, { val: data.quantity, stream: false, onlyval: false })))),
                            React.createElement("div", { className: "mobile-summ-row" },
                                " ",
                                React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                    React.createElement("span", { className: "txt_secondary-gray DMSansNormal_12_400" }, "Net Value"),
                                    React.createElement("span", { className: "RobotoM_14_500 num" },
                                        React.createElement(ReportValue, { val: data.netValue, stream: false, onlyval: false })))))))),
                    (approximatedEstimates === null || approximatedEstimates === void 0 ? void 0 : approximatedEstimates.editSplitOriginalTransaction.findIndex((x) => x.edited)) > -1 && (React.createElement(ErrorExclamation, { avoidExclamation: true, parentClass: "error-authorize-approximate", errorMessage: THApproximateTransEditsDone, childClass: "justify-content-center DMSanM_14_500" })),
                    React.createElement("div", { className: "accept-and-save-section d-flex flex-column " },
                        React.createElement("div", { className: "accept-section" },
                            React.createElement("div", { className: "height_width_check transaction-button" },
                                React.createElement("input", { type: "checkbox", checked: termsAndConditions, className: `common-checkbox-custom ${termsAndConditions ? "" : "opacity-25"}`, onChange: (e) => setTermsAndConditions(e.target.checked) })),
                            React.createElement("div", { className: "DMSansMedium_12_500 accept-approx-txn" },
                                "I accept the above approximated transactions, I ",
                                React.createElement("br", null),
                                "understand that they\u00A0",
                                React.createElement("span", { className: "txt-tomato" }, "will not be editable once accepted."))),
                        React.createElement("div", { className: "save-button-approximation text-center " },
                            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Save Approximations", className: "transaction-10 DMSanM_14_500 w-100", onClick: saveApproximations, disabled: !termsAndConditions || listOfCheckedItems.length < 1 }, "Save Approximations")))))), parentClassname: "common-sidebar-new  transaction-history-container", footer: "" }));
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "" },
                React.createElement("div", { className: "txt-midnight-blue d-flex align-items-center gap-2" },
                    React.createElement("span", { onClick: () => props.setTHViews(THVIEWS.MAIN_LANDING) },
                        React.createElement("i", { className: "edel-icon-arrow-left1 hand_cursor" })),
                    React.createElement("span", { className: "DMSan_28_700" }, "Approximated Transactions")),
                React.createElement("div", { className: "transaction_dataTime DMSansMedium_12_500" },
                    React.createElement("div", null,
                        "Below report as on ",
                        moment(previousDay).format("DD-MMM-YY")))),
            React.createElement(ErrorExclamation, { avoidExclamation: true, parentClass: "error-authorize-approximate top-notification", errorMessage: THApproximateTrans, childClass: "txt-orange-light" }),
            React.createElement(GenericTable, { columns: THTableColumn, data: approximatedEstimates === null || approximatedEstimates === void 0 ? void 0 : approximatedEstimates.editSplitOriginalTransaction, parentClassName: `common-table-border table approximate-txns ${(approximatedEstimates === null || approximatedEstimates === void 0 ? void 0 : approximatedEstimates.editSplitOriginalTransaction.findIndex((x) => x.edited)) > -1
                    ? ""
                    : "pt-3 pb-5"} `, shimmer: React.createElement(Common_Shimmer, { number: 5 }), loader: appromiateEstimatesLoader, message: approximateTableErrorHandling(), rowOnClick: props.handleRowClick }),
            (approximatedEstimates === null || approximatedEstimates === void 0 ? void 0 : approximatedEstimates.editSplitOriginalTransaction.findIndex((x) => x.edited)) > -1 && (React.createElement(ErrorExclamation, { avoidExclamation: true, parentClass: "error-authorize-approximate edit-auth", errorMessage: THApproximateTransEditsDone, childClass: "justify-content-center DMSanM_14_500 txt-orange-light" })),
            React.createElement("div", { className: "approximation-bottom transaction-button fixed-bottom bg_white p-2" },
                React.createElement("div", { className: "container d-flex justify-content-between " },
                    React.createElement("div", { className: "d-flex align-items-center" },
                        React.createElement("div", { className: "height_width_check mr-10 common-checkbox-custom" },
                            React.createElement("input", { type: "checkbox", checked: termsAndConditions, onChange: (e) => setTermsAndConditions(e.target.checked) })),
                        React.createElement("div", { className: "DMSanM_14_500" },
                            "I accept the above approximated transactions, I understand that they\u00A0",
                            React.createElement("span", { className: "txt-tomato" }, "will not be editable once accepted"))),
                    React.createElement("div", { className: "save-button-approximation DMSanM_14_500" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Save Approximations", className: " transaction-10 ", onClick: saveApproximations, disabled: !termsAndConditions || listOfCheckedItems.length < 1 }, "Save Approximations")))))));
};
export default ApproximateTransaction;
